import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "back-image" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "text-in-image" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Pendiente de pago", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, " Inicia sesión en otro perfil para acceder a la compra de planes. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Estamos a punto de comenzar. El estado de tu pago:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_font_awesome_icon, {
        class: "rotate",
        icon: ['fas', _ctx.icono],
        size: "3x"
      }, null, 8, ["icon"]),
      _createElementVNode("div", null, [
        (_ctx.isRestricted)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _hoisted_5
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_6,
              _createElementVNode("h1", null, _toDisplayString(_ctx.estadoPago) + ".", 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.mensaje), 1)
            ], 64))
      ])
    ])
  ]))
}